import styled from "styled-components";

export const UnderlineTextButton = styled.button`
  background-color: transparent;
  color: ${({ theme }): string => theme.colors.yellow};
  font-size: 1rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  align-self: flex-start;
  text-align: flex-start;
  padding-left: 0;
  font-size: 0.8rem;
  text-decoration: underline;
  margin-bottom: 1rem;
  opacity: ${({ disabled }): number => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }): string => (disabled ? "none" : "auto")};
`;
